<template>
 
<div class="fund-selector">

  <div class="fund-selector__dropdown">
    <select id="currency" v-model="selectedCurrency" @change="updateChart"> 
           <option value="TL">Türk Lirası</option>
          <option value="USD">Dolar</option>
          <option value="EUR">Euro</option>
          <option value="AU">Altın</option>
        </select>
  </div>
 
</div>
<hr/>

</template>

<script>
export default {
data(){
  return{
    selectedCurrency:"TL",
  };
},
methods:{
  updateChart(){
    this.$emit("currencyChange",this.selectedCurrency)
  }
}
}
</script>

<style>
.fund-selector{
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 250px;
  align-items: flex-end;
}

.fund-selector__dropdown select{
justify-content: space-between;
display: flex;
padding: 10px;
font-size: 14px;
color:#0056b3;
border: 0px solid #ccc;
border-radius: 4px;
background-color: #fff;
outline:invert;
}

.fund-selector__dropdown select:hover{
  border-color: #007bff;
}
.fund-selector__dropdown select:focus{
  border-color: #0056b3;
  box-shadow: 0 0 4px rgba(0, 123, 255, 0.5);
}

</style>